/**
 * Apple Wallet is supported on Mac (all browsers) & iPhone/iPod Touch (all browsers excl. Chrome).
 * Apple Wallet is not supported on iPad at this time.
 */
export const isAppleWalletSupported = () => {
    switch (navigator.platform) {
        case 'MacIntel':
            // Apple started identifying iPad as "MacIntel" from iPadOS 13, so we also need to check if the device has a touch screen
            return navigator.maxTouchPoints === 0;
        case 'iPhone':
        case 'iPod':
            // Apple Wallet is not supported in Chrome on iOS
            return !/CriOS/i.test(navigator.userAgent);
        default:
            return false;
    }
};
/**
 * Opening the Apple Wallet PKPass file will prompt the patron to add the pass to their Apple Wallet.
 */
export const openAppleWalletPass = (appleWalletPass) => {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(appleWalletPass);
    link.click();
};
